import React from "react";
import { useSelector } from "react-redux";
import styles from "./toastScreenleft.module.scss";
import nodata from "../../../styles/images/nosmall.svg";
import erroricon from "../../../styles/images/erricons.svg";

import { callMainPageInterface } from "../../../models/callModel";
import { undoToastInfo } from "../../../base/callService/common";
import { initialStateModel, LoginState } from "../../../models/model";
import { ChatService } from "../../../base/chatService";
import { Types } from "../../../context/action/action";
import store from "../../../context/store/store";
import { useHistory } from "react-router-dom";

/*type toastLeftState = {
  message: string
}*/


export default function ToastLeft() {

  /*const [toastLeftState, setToastLeftState] = useState<toastLeftState>
  ({
    message: ''
  });*/
  const history = useHistory();
  const { toastReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  const chatReducer: any = useSelector((state: any) => state.chatReducer);
  let { message, isEnableUndo } = toastReducer;
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const openMyspace=()=>{
    if(window.location.pathname==="/contacts"){
      history.push('/chats');
    }
    let mySpaceDetials:any =loginDetails.userdetails;
    mySpaceDetials.isMySpace = true;
    mySpaceDetials.jid = `${mySpaceDetials.sip_login_id}@${mySpaceDetials.host_address}`;
    ChatService.openChatWindow(mySpaceDetials);
    ChatService.emptyOnMyspace();
    ChatService.editDraft("");
    let ActiveTabs;
    if(chatReducer.isEventviewontoast){
      ActiveTabs="3"

    }
    if(chatReducer.isTaskviewontoast){
      ActiveTabs="2"
    }
    if(chatReducer.isNotesviewontoast){
      ActiveTabs="6"
    }
    store.dispatch({
      type: Types.TAB_CHANGE,
      payload: {
        ActiveTab: ActiveTabs
      }
    });

  };

  return (
    <>  
      <div className={styles.toastScreenleft}>
      <img src={erroricon} alt="" />
        <span className="">{message}</span>
        {isEnableUndo && <span className={styles.undoButton}
          onClick={() => undoToastInfo(false,false,true)}>Undo</span>}
          {
           (chatReducer.isEventviewontoast||chatReducer.isTaskviewontoast||chatReducer.isNotesviewontoast ) &&
          chatReducer.isViewbutton
          &&<div>
        <span onClick={openMyspace}className={styles.viewLinkTxt}>view</span>
      </div>}
        <span className="icon_close" onClick={() => undoToastInfo(false,false,false)}></span>
      </div>
      <div className={styles.noInternetCon}>
        <img src={nodata} alt="" />
        <span className="">Hmmm, you are not Connected</span>
        <span className={styles.undoButton} >Undo</span>
        <span className="icon_close"></span>
      </div>
     
    </>
  );
};